import axios, { AxiosInstance } from 'axios'
import { getToken, getUrlApi, setStorage } from './utils'

export function createLoginHttp(version: string = 'v1'): AxiosInstance {
  return axios.create({
    baseURL: getUrlApi('login', version)
  })
}

export const LOGINv1: AxiosInstance = createLoginHttp('v1')
export const LOGINv2: AxiosInstance = createLoginHttp('v2')

export class LoginService {
  httpClient: AxiosInstance

  constructor(httpClient: AxiosInstance = LOGINv1) {
    this.httpClient = httpClient
  }
}

const addLoginInterceptors = (httpInstance: AxiosInstance) => {
  httpInstance.interceptors.request.use(
    (config) => {
      const TOKEN = getToken()
      config.headers = config.headers ?? {}

      if (TOKEN) {
        config.headers.Authorization = `Bearer ${TOKEN}`
      } else {
        delete config.headers.Authorization
      }

      return config
    },
    (error) => Promise.reject(error),
  )

  httpInstance.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      const defaultMessage = 'Erro na requisição, tente novamente.'
  
      if (!error.response) {
        throw new Error(defaultMessage)
      }
  
      const { status } = error.response
      const [message] = error.response?.data?.errors || ''
  
      if (status) {
        if (status === 401) {
          localStorage.clear()
          setStorage('disconnect', 'true')

          setTimeout(() => {
            window.location.href = '/login'
          }, 2000)
        }
        throw new Error(message || defaultMessage)
      }
  
      return Promise.reject(error)
    },
  )
}

addLoginInterceptors(LOGINv1)
addLoginInterceptors(LOGINv2)
